import { Chart, phxWebStyleTokens } from 'phx-core';
import { Component, Input } from '@angular/core';

enum HEIGHT_CATEGORY {
  auto='auto',
  noHeight='noHeight',
  full='full',
}

const HEIGHT_CLASS_MAPPING: Record<keyof typeof HEIGHT_CATEGORY, string>  = {
  auto : 'h-auto',
  noHeight : 'h-0',
  full: 'h-100',
};

@Component({
  selector: 'table-empty-state',
  templateUrl: './table-empty-state.component.html',
  styleUrls: ['./table-empty-state.component.scss'],
})
export class TableEmptyStateComponent {
  @Input() public icon: string = Chart;
  @Input() public iconColor: string = phxWebStyleTokens.colorContentEmphasis;
  @Input() public message: string = $localize`No results found. Please update search criteria.`;
  @Input() public iconSize: number = 64;
  @Input() public height: string = HEIGHT_CLASS_MAPPING.full;
  public readonly HEIGHT_CLASS_MAPPING: Record<keyof typeof HEIGHT_CATEGORY, string> = HEIGHT_CLASS_MAPPING;
}